import { defineComponent as h, ref as y, computed as l, createElementBlock as V, openBlock as I, createVNode as r, unref as n, mergeProps as A } from "vue";
import { RevButtonIcon as k } from "@ds/components/ButtonIcon";
import { RevInputText as w } from "@ds/components/InputText";
import B from "../../icons/generated/IconEyeClosed.vue2.js";
import L from "../../icons/generated/IconEyeOpen.vue2.js";
const g = {
  class: "relative",
  "data-test": "input-password"
}, R = /* @__PURE__ */ h({
  inheritAttrs: !1,
  __name: "InputPassword",
  props: {
    hideAriaLabel: {},
    showAriaLabel: {},
    description: { default: "" },
    error: { default: void 0 },
    id: {},
    label: {},
    modelValue: {},
    disabled: { type: Boolean },
    required: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "input", "invalid", "valid"],
  setup(i, { emit: d }) {
    const o = i, t = d, a = y(!0), s = () => {
      a.value = !a.value;
    }, u = l(() => a.value ? L : B), p = l(() => a.value ? "password" : "text"), c = l(() => a.value ? o.showAriaLabel : o.hideAriaLabel), m = (e) => {
      t("update:modelValue", e);
    }, v = (e) => {
      t("input", e);
    }, b = (e) => {
      t("invalid", e);
    }, f = () => {
      t("valid");
    };
    return (e, q) => (I(), V("div", g, [
      r(n(w), A({ id: e.id }, e.$attrs, {
        description: e.description,
        disabled: e.disabled,
        error: e.error,
        "has-clear-button": !1,
        label: e.label,
        "model-value": e.modelValue,
        required: e.required,
        type: p.value,
        onInput: v,
        onInvalid: b,
        "onUpdate:modelValue": m,
        onValid: f
      }), null, 16, ["id", "description", "disabled", "error", "label", "model-value", "required", "type"]),
      r(n(k), {
        "aria-label": c.value,
        class: "absolute inset-y-4 right-4 cursor-pointer",
        "data-test": "reveal-button",
        icon: u.value,
        type: "button",
        variant: "secondary",
        onClick: s
      }, null, 8, ["aria-label", "icon"])
    ]));
  }
});
export {
  R as default
};
